import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { HttpService } from '../../services/http.service';
import { URLUtils } from '../../urlUtils';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-forgotpwd',
    templateUrl: './forgotpwd.component.html',
    styleUrls: ['./forgotpwd.component.scss'],
    standalone: false
})
export class ForgotpwdComponent {

  @Output() event = new EventEmitter<any>();

  constructor(private formBuilder: FormBuilder,
              private httpservice: HttpService,
              private toast: ToastrService) { }

  submitted = false;
  show_password = false
  show_confirmpassword = false
  emailForm: any = FormGroup;
  showFirms: boolean = false;
  msg: string = "";
  firms: any[] = [];
  multiFirm: boolean = false;
 

  ngOnInit() {
    this.emailForm = this.formBuilder.group({email: ['', [Validators.required, this.emailOrMobileValidator]],
                                             firm: ['']})
  }

  get f() { return this.emailForm.controls; }

  emailOrMobileValidator(control: any) {
    if (!control.value) return null;

    const value = control.value.trim();

    const emailRegex =
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    // const mobileRegex =
    //   /^[6-9][0-9]{9}$/;

    // if (emailRegex.test(value) || mobileRegex.test(value)) {
    //   return null;
    // }

    if (emailRegex.test(value)) {
      return null;
    }

    return { invalidIdentifier: true };
  }

  cancelml(){
    this.event.emit({'msg': 'forgot-cancel'})
  }

  onSubmit() {
    this.msg = "";
    this.submitted = true;

    const form = this.emailForm;
    console.log('form',form)

    if (form.invalid) {
      return;
    }

    const identifier = form.value['email']?.trim();

    const data: any = {
      plan: environment.product
    };

    if (identifier.includes('@')) {
      data.email = identifier.toLowerCase();
    } 
    // else {
    //   data.mobile = identifier;
    // }

    if (this.showFirms) {
      data.userid = form.value['firm'];
    }

    this.httpservice.sendPutRequest(URLUtils.forgotPwd, data).subscribe(
      (resp: any) => {

        if (resp.error === true && resp.msg) {
          this.toast.error(resp.msg);
          this.showFirms = false;
          return;
        }

        if (resp.error) {
          this.showFirms = true;
          this.firms = resp.firms[environment.product];
        } else {
          this.event.emit({ msg: 'forgot-success' });
        }
      }
    );
  }

  // onSubmit(){
  //   this.msg = ""
  //   this.submitted = true
  //   let form = this.emailForm
  //   if(form.invalid) { return; }
  //   let data: any = {
  //     'email': form.value['email'], 
  //     'plan': environment.product
  //   }
  //   if(this.showFirms){
  //     data['userid'] = form.value['firm']
  //   }
  //   this.httpservice.sendPutRequest(URLUtils.forgotPwd, data).subscribe(
  //     (resp: any) => {
  //       // console.log('err resp',resp)

        
  //       if(resp.error == true && resp.msg){
  //         this.toast.error(resp.msg);
  //          this.showFirms = false;
  //         return;
  //       }
  //       else if(resp['error']){
  //         // if(this.showFirms){
  //           this.showFirms = true
  //           this.firms = resp['firms'][environment.product]
  //         //}
  //         //this.toast.error(resp.msg);
  //       } 
  //       else {
  //          this.event.emit({'msg':'forgot-success'})
  //       }
  //   })
  // }

  removeLeadingSpace(event: any) {
    const value = event.target.value;

    if (value.startsWith(' ')) {
      event.target.value = value.trimStart();
      this.emailForm.get('email')?.setValue(event.target.value);
    }
  }

}
